import React, { Component } from "react";

//IMPORT IMAGES
import subjectsImg from '../../frontend/assets/img/Jainism/subjects-img.png';
import subjectartImg from '../../frontend/assets/img/Jainism/subjectart.png';
import sub1Img from '../../frontend/assets/img/Jainism/sub1.png';
import sub2Img from '../../frontend/assets/img/Jainism/sub2.png';
import sub3Img from '../../frontend/assets/img/Jainism/sub3.png';
import sub4Img from '../../frontend/assets/img/Jainism/sub4.png';
import sub5Img from '../../frontend/assets/img/Jainism/sub5.png';
import bookboyHQImg from '../../frontend/assets/img/Jainism/bookboyHQ.png';
import bookImg from '../../frontend/assets/img/Jainism/book.png';
import schoolbagSvgImg from '../../frontend/assets/img/Jainism/schoolbag.svg';

class Subjects extends Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }

    render() {
        return (
            <React.Fragment>
                <section className="simple-section space">
                    <div className="row g-0 align-items-center">
                        <div className="col-xl-5 col-lg-12 wow fadeInLeft" data-wow-delay="0.1s">
                            <div className="img-box-1">
                                <img src={subjectsImg} alt="photo" />
                            </div>
                            <div className="subvector">
                                <img src={subjectartImg} alt="photo" />
                            </div>
                        </div>
                        <div className="col-xl-7 col-lg-12 wow fadeInRight" data-wow-delay="0.1s">
                            <div className="content-box">

                                <h2 className="sec-title">Our Subjects</h2>
                                <p className="mb-50" style={{ fontSize: 30 }}>We have a school uniform of white and a white dress code; along with that, we provide a school bag, ID card, diary, and syllabus book.

                                    Yearly 2 exams are conducted, On the basis of yearly performance of the students and exam performance, we chose and declare Student of the year in order to motivate and inspire them.</p>
                                <div className="simple-block">
                                    <div className="feature-box-two">
                                        <div className="feature-icon">
                                            <img src={sub1Img} alt="icon" />
                                        </div>
                                        <div className="feature-info">
                                            <h4 className="feature-title">GYAAN SANSKAR</h4>
                                        </div>
                                    </div>
                                    <div className="feature-box-two">
                                        <div className="feature-icon">
                                            <img src={sub2Img} alt="icon" />
                                        </div>
                                        <div className="feature-info">
                                            <h4 className="feature-title">DARSHAN SANSKAR</h4>
                                        </div>
                                    </div>
                                    <div className="feature-box-two">
                                        <div className="feature-icon">
                                            <img src={sub3Img} alt="icon" />
                                        </div>
                                        <div className="feature-info">
                                            <h4 className="feature-title">CHARITRA SANSKAR</h4>
                                        </div>
                                    </div>
                                    <div className="feature-box-two">
                                        <div className="feature-icon">
                                            <img src={sub4Img} alt="icon" />
                                        </div>
                                        <div className="feature-info">
                                            <h4 className="feature-title">TAP SANSKAR</h4>
                                        </div>
                                    </div>
                                    <div className="feature-box-two">
                                        <div className="feature-icon">
                                            <img src={sub5Img} alt="icon" />
                                        </div>
                                        <div className="feature-info">
                                            <h4 className="feature-title">G.K. SANSKAR</h4>
                                        </div>
                                    </div>
                                </div>
                                <img className="image bookboyvector" src={bookboyHQImg} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="wave shapePulse d-none d-lg-block book-float" style={{ width: "20%" }}><img src={bookImg} alt="shapes" /></div>
                    <div className="letter shapePulse d-none d-lg-block schoolbag-vector"><img src={schoolbagSvgImg} alt="shapes" /></div>
                </section>
            </React.Fragment >
        );
    }
}

export default Subjects;
